import {Component} from "react";
import styles from "../index.css";
import {observer} from 'mobx-react';
import Drag from "../../DragNDrop/Drag";
import React from "react";

@observer
export default class TabListElement extends Component{
    render(){
        const DomElement = this.props.DomElement;
        const item = this.props.item;
        const hoverElementCheck = this.props.hoverElementCheck;
        return(
            <div className={styles.footerDND}>
                <Drag
                    onDrag={this.props.setDrop}
                    type={(item.type !== 'output'  ? "intermediate" : "endElement") + (item.type === 'silo' || item.type === 'hopper' ? ",endElement" : '')}
                    maskClassName={styles.mask} onMouseOver={this.props.onMouseOver.bind(this)}
                >
                    <div  className={styles.actionCircle  + (hoverElementCheck.tabs === "tabs" && hoverElementCheck.id === this.props.id?  " " + styles.currentItem : '')} >
                        {item.type === 'output' || item.type === 'silo' ?
                            <DomElement item={item} inPath={true}/>
                            :
                            <div className={styles.actionDCContainer}><DomElement item={item} inPath={true}/></div>
                        }
                    </div>
                </Drag>
                <div className={styles.dragDesciption}>
                    №{item.num+1}<br/>
                    {item.name}<br/>{item.totalCapacity ? item.totalCapacity+'т' : ''}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/shared/components/PathPopup/TabListElement/index.js